{
  "appName": "Track your VR&E benefits",
  "entryFile": "./app-entry.jsx",
  "entryName": "track-your-vre-benefits",
  "rootUrl": "/careers-employment/track-your-vre-benefits/vre-benefit-status",
  "productId": "edb97eef-35de-4c46-ac48-ecc5736e62e4"
}
